import { h, Component } from 'preact';
import { CloverIcon, HelpButton, JoinButton, RoyalWinModal, RoyalWinOverlay, Winner, WinnersList, PromoHeader, PromoFooter } from '../mobile-templates/royal-wins';
import { SlotTournamentsService, LeaderboardEntry, PrizeTier, SuccessDetailsApiResponse } from '../../../services/slot-tournaments';
import { route } from 'preact-router';
import PageDataFeed from '../../../services/page-data-feed';

import AwrabetRoyalWinsController from '../../awrabet/mobile-components/royal-wins';

export class RoyalWinsController extends AwrabetRoyalWinsController {
    render() {
        const { isLoading, showModal, winners } = this.state;

        if (isLoading || !showModal) {
            return null;
        }

        return <RoyalWinOverlay onClose={this.handleClose}>
            <CloverIcon class="absolute top-10 right-10 w-16 h-16 text-blue-whale-600 opacity-20" />
            <PromoHeader onClose={this.handleClose}>
                <div class="text-white">
                    <div class="text-3xl font-bold text-custom-orange">5,000,000</div>
                    <div class="text-xs">1000 PLAYERS x 3,000 MAX x 100 DAYS!</div>
                    <div class="text-xxs">ለመቶ ቀናቶች የሚቆይ 5,000,000 ብር ሽልማት፣ በየዕለቱ 50,000 ብር ለ1,000 ደንበኞች እስከ 3,000 ብር ድረስ፦ አሁኑኑ ይቀላቀሉ!</div>
                </div>
            </PromoHeader>
            <WinnersList winners={winners} />
            <PromoFooter>
                <HelpButton onClick={() => {this.handleClose();route("/promo/victory-vault")}} />
                <JoinButton onClick={() => {this.handleClose();route("/slot-tournaments/"+this.state.tournamentId)}} />
            </PromoFooter>
        </RoyalWinOverlay>
    }
}

export default RoyalWinsController;